import { render } from "./WordList.vue?vue&type=template&id=2a723f84"
import script from "./WordList.vue?vue&type=script&lang=ts"
export * from "./WordList.vue?vue&type=script&lang=ts"

import "./WordList.vue?vue&type=style&index=0&id=2a723f84&lang=scss"
script.render = render

export default script